import React from 'react'

const Spinner = () => {
    return (
        <div style={{textAlign:"center"}}>
            <i  className="fas fa-spinner fa-spin" style={{fontSize:"30px"}}></i>
        </div>
    )
}
export default Spinner
